"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * USCIS Verifications Identity Service
 * An [Oauth 2.0](https://tools.ietf.org/html/rfc6749) compliant API which wraps the [identity providers](https://maestro.dhs.gov/confluence/display/VERST/Identity+Providers) used in the USCIS Verifications ecosystem.
 *
 * The version of the OpenAPI document: 2.4.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizeStepBCodeChallengeMethodEnum = exports.AuthorizeStepALandingpageEnum = exports.AuthorizeStepACodeChallengeMethodEnum = exports.AuthorizeStepAResponseTypeEnum = exports.AuthorizationApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var AuthorizationApi = /** @class */ (function (_super) {
    __extends(AuthorizationApi, _super);
    function AuthorizationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * As step (A) of the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1). Supply the query parameters as described by https://tools.ietf.org/html/rfc6749#section-4.1.1.<br> The response will be a redirect to the  Identity Provider associated to the `clientId` provided at time of on-boarding.<br> An Authorization Code will then be supplied, step (C), as a form field parameter to the supplied `redirect_uri`. This `code` can then be used with the /token endpoint, Steps (D, E).
     * An endpoint for receiving an Access Code which can subsequently be used by the /token endpoint.
     */
    AuthorizationApi.prototype.authorizeStepARaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.responseType === null || requestParameters.responseType === undefined) {
                            throw new runtime.RequiredError('responseType', 'Required parameter requestParameters.responseType was null or undefined when calling authorizeStepA.');
                        }
                        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling authorizeStepA.');
                        }
                        if (requestParameters.redirectUri === null || requestParameters.redirectUri === undefined) {
                            throw new runtime.RequiredError('redirectUri', 'Required parameter requestParameters.redirectUri was null or undefined when calling authorizeStepA.');
                        }
                        queryParameters = {};
                        if (requestParameters.responseType !== undefined) {
                            queryParameters['response_type'] = requestParameters.responseType;
                        }
                        if (requestParameters.clientId !== undefined) {
                            queryParameters['client_id'] = requestParameters.clientId;
                        }
                        if (requestParameters.redirectUri !== undefined) {
                            queryParameters['redirect_uri'] = requestParameters.redirectUri;
                        }
                        if (requestParameters.role !== undefined) {
                            queryParameters['role'] = requestParameters.role;
                        }
                        if (requestParameters.scope !== undefined) {
                            queryParameters['scope'] = requestParameters.scope;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.codeChallenge !== undefined) {
                            queryParameters['code_challenge'] = requestParameters.codeChallenge;
                        }
                        if (requestParameters.codeChallengeMethod !== undefined) {
                            queryParameters['code_challenge_method'] = requestParameters.codeChallengeMethod;
                        }
                        if (requestParameters.landingpage !== undefined) {
                            queryParameters['landingpage'] = requestParameters.landingpage;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/authorize",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * As step (A) of the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1). Supply the query parameters as described by https://tools.ietf.org/html/rfc6749#section-4.1.1.<br> The response will be a redirect to the  Identity Provider associated to the `clientId` provided at time of on-boarding.<br> An Authorization Code will then be supplied, step (C), as a form field parameter to the supplied `redirect_uri`. This `code` can then be used with the /token endpoint, Steps (D, E).
     * An endpoint for receiving an Access Code which can subsequently be used by the /token endpoint.
     */
    AuthorizationApi.prototype.authorizeStepA = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authorizeStepARaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Steps (B) and (C) of the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1) flow. Will exist while Legacy is still serving as the Identity Provider. The URL of this endpoint will be returned as part of the 302 redirect from the GET /authorization endpoint during this intermediate phase.
     * An endpoint for receiving an Authorization Code provided user credentials
     */
    AuthorizationApi.prototype.authorizeStepBRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling authorizeStepB.');
                        }
                        if (requestParameters.redirectUri === null || requestParameters.redirectUri === undefined) {
                            throw new runtime.RequiredError('redirectUri', 'Required parameter requestParameters.redirectUri was null or undefined when calling authorizeStepB.');
                        }
                        if (requestParameters.username === null || requestParameters.username === undefined) {
                            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling authorizeStepB.');
                        }
                        if (requestParameters.password === null || requestParameters.password === undefined) {
                            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling authorizeStepB.');
                        }
                        queryParameters = {};
                        if (requestParameters.clientId !== undefined) {
                            queryParameters['client_id'] = requestParameters.clientId;
                        }
                        if (requestParameters.redirectUri !== undefined) {
                            queryParameters['redirect_uri'] = requestParameters.redirectUri;
                        }
                        if (requestParameters.scope !== undefined) {
                            queryParameters['scope'] = requestParameters.scope;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.codeChallenge !== undefined) {
                            queryParameters['code_challenge'] = requestParameters.codeChallenge;
                        }
                        if (requestParameters.codeChallengeMethod !== undefined) {
                            queryParameters['code_challenge_method'] = requestParameters.codeChallengeMethod;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.username !== undefined) {
                            formParams.append('username', requestParameters.username);
                        }
                        if (requestParameters.password !== undefined) {
                            formParams.append('password', requestParameters.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/authorize",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AuthorizationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Steps (B) and (C) of the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1) flow. Will exist while Legacy is still serving as the Identity Provider. The URL of this endpoint will be returned as part of the 302 redirect from the GET /authorization endpoint during this intermediate phase.
     * An endpoint for receiving an Authorization Code provided user credentials
     */
    AuthorizationApi.prototype.authorizeStepB = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authorizeStepBRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Flush all session tokens and return the specified redirect URL. If the relevant Identity Provider has a corresponding endpoint, the Identity Provider will ultimately return the URL in the response body.
     * Ends the current session. (Logs out the current user.)
     */
    AuthorizationApi.prototype.endSessionRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.clientId !== undefined) {
                            queryParameters['client_id'] = requestParameters.clientId;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/end_session",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Flush all session tokens and return the specified redirect URL. If the relevant Identity Provider has a corresponding endpoint, the Identity Provider will ultimately return the URL in the response body.
     * Ends the current session. (Logs out the current user.)
     */
    AuthorizationApi.prototype.endSession = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.endSessionRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * As a preliminary step to the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1). Supply the query parameter \'state\', as described further within https://tools.ietf.org/html/rfc6749#section-4.1.1.<br> The response object will contain a string which modifies the supplied state parameter with the userId from the request\'s access token and a signature for verification further in the authorization flow. This state parameter can be used in a subsequent Authorize call (Step A) and will flow through the redirect to an external IDP to provide context on the user requesting authorization.
     * A secure endpoint for updating and returning a supplied state parameter with an authenticated user\'s Id and a signature, each delimited by \'.\' characters
     */
    AuthorizationApi.prototype.migrationStateAppendUserIdRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            token = this.configuration.accessToken;
                            tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                            if (tokenString) {
                                headerParameters["Authorization"] = "Bearer " + tokenString;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v1/migration-state-append-user-id",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.MigrationStateResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * As a preliminary step to the [Authorization Code Grant](https://tools.ietf.org/html/rfc6749#section-4.1). Supply the query parameter \'state\', as described further within https://tools.ietf.org/html/rfc6749#section-4.1.1.<br> The response object will contain a string which modifies the supplied state parameter with the userId from the request\'s access token and a signature for verification further in the authorization flow. This state parameter can be used in a subsequent Authorize call (Step A) and will flow through the redirect to an external IDP to provide context on the user requesting authorization.
     * A secure endpoint for updating and returning a supplied state parameter with an authenticated user\'s Id and a signature, each delimited by \'.\' characters
     */
    AuthorizationApi.prototype.migrationStateAppendUserId = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.migrationStateAppendUserIdRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return AuthorizationApi;
}(runtime.BaseAPI));
exports.AuthorizationApi = AuthorizationApi;
/**
    * @export
    * @enum {string}
    */
var AuthorizeStepAResponseTypeEnum;
(function (AuthorizeStepAResponseTypeEnum) {
    AuthorizeStepAResponseTypeEnum["Code"] = "code";
})(AuthorizeStepAResponseTypeEnum = exports.AuthorizeStepAResponseTypeEnum || (exports.AuthorizeStepAResponseTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AuthorizeStepACodeChallengeMethodEnum;
(function (AuthorizeStepACodeChallengeMethodEnum) {
    AuthorizeStepACodeChallengeMethodEnum["S256"] = "S256";
})(AuthorizeStepACodeChallengeMethodEnum = exports.AuthorizeStepACodeChallengeMethodEnum || (exports.AuthorizeStepACodeChallengeMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AuthorizeStepALandingpageEnum;
(function (AuthorizeStepALandingpageEnum) {
    AuthorizeStepALandingpageEnum["SignIn"] = "signIn";
    AuthorizeStepALandingpageEnum["SignUp"] = "signUp";
})(AuthorizeStepALandingpageEnum = exports.AuthorizeStepALandingpageEnum || (exports.AuthorizeStepALandingpageEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AuthorizeStepBCodeChallengeMethodEnum;
(function (AuthorizeStepBCodeChallengeMethodEnum) {
    AuthorizeStepBCodeChallengeMethodEnum["S256"] = "S256";
})(AuthorizeStepBCodeChallengeMethodEnum = exports.AuthorizeStepBCodeChallengeMethodEnum || (exports.AuthorizeStepBCodeChallengeMethodEnum = {}));
